<template>
  <div id="teacher_guide_wrapper">

    <div v-if="items.banner_image" class="banner" :style="{backgroundImage: 'url(' + items.banner_image.url_resized_large + ')'}">
      <div class="container py-5">
        <div class="row">
          <div class="col-6">
            
            <div class="logo mb-4 mt-2">
              <SVGLogoEn v-if="$i18n.locale == 'en'"></SVGLogoEn>
              <SVGLogoFr v-else></SVGLogoFr>
            </div>
            
            <h1 class="h2">{{ $t(iKey('teacher_guide', 'ui', 'headline')) }}</h1>
            <div class="intro-description" v-html="$t(iKey('teacher_guide', 'ui', 'description'))"></div>
            
              <a v-for="(doc, index) in items.related_lesson_documents" 
                target="_blank"
                :id="`btn-download-guide-${index}`"
                :key="index" class="mr-4 my-2 btn-download" 
                :href="$t(iKey('teacher_guide', 'overview_doc_' + index, 'url'))" download>
                {{ $t(iKey('teacher_guide', 'overview_doc_' + index, 'label')) }}
              </a>
            
          </div>
          <div class="col-6"></div>
        </div>

      </div>
    </div>
    <div class="tip-box">
      <div class="container py-4">
        <div class="row">
          <div class="col-8 guide-text">{{ $t(iKey('teacher_guide', 'ui', 'tip_box')) }}</div>
        </div>
      </div>
    </div>
    <div class="lessons-wrapper">
      <div v-for="(lesson, index) in items.lessons" :key="index">
      <div class="container py-5">
        <div class="row mb-5" >
          <div class="col-6">
            <h2 class="h5">{{ $t(iKey('teacher_guide', 'lesson_' + index, 'label') )}}</h2>

            <h3 class="guide-text">{{ $t(iKey('teacher_guide', 'ui', 'lesson_objective_label')) }}</h3>
            <p>{{ $t(iKey('teacher_guide', 'lesson_' + index, 'objective') )}}</p>
            
            <h3 class="guide-text">{{ $t(iKey('teacher_guide', 'ui', 'lesson_summary_label')) }}</h3>
            <div class="smaller" v-html="$t(iKey('teacher_guide', 'lesson_' + index, 'summary') )"></div>
            
            <h3 class="guide-text">{{ $t(iKey('teacher_guide', 'ui', 'lesson_activities_label')) }}</h3>
            
            <ul class="list-unstyled">
              <li v-for="(doc, doc_i) in lesson.value.activities" :key="doc_i">
                <a class="p"
                  target="_blank"
                  v-if="doc.document_en" 
                  :href="$t(iKey('teacher_guide', 'lesson_' + index + '_doc_' + doc_i, 'url'))" 
                  download>{{ $t(iKey('teacher_guide', 'lesson_' + index + '_doc_' + doc_i, 'title')) }}</a>
                <span class="p" v-else>{{ $t(iKey('teacher_guide', 'lesson_' + index + '_doc_' + doc_i, 'title')) }}</span>
              </li>
            </ul>
          </div>
          
          <div class="col-6">
            <img class="img-fluid" :src="$t(iKey('teacher_guide', 'lesson_' + index, 'screenshot_url'))" >
          </div>

        </div>
      </div>
      <hr>      
      </div>
    </div>

  </div>
</template>

<script>

import { mapState } from 'vuex'
import SVGLogoEn from '@/assets/icons/cmhr-logo-en.svg'
import SVGLogoFr from '@/assets/icons/cmhr-logo-fr.svg'

export default {
  name: 'TeacherGuide',
  components: {
    SVGLogoEn,
    SVGLogoFr,
  },
  computed: {
    ...mapState('teacherGuide', ['items']),
  },
  mounted() {
    this.$store.dispatch('teacherGuide/GET_ITEMS')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.lessons-wrapper .guide-text {
  margin-top: 2em;
}
.smaller p {
  font-size: 20px;
}

/* targeting p elements in rich text editor */
div.p p, p {
  font-size: 20px;
  line-height: 32px;
}
a.p {
  text-decoration: underline;
  color: white;
}
.btn-download {
  border: 2px solid white;
  display: inline-block;
  padding: 20px;
  color: white;
  font-family: 'UniversLTPro-65Bold'
}
.banner {
  background-color: #459fb2;
  color: white;
  background-position: right;
  background-size: contain;
  background-repeat: no-repeat;
}
.tip-box {
  background-color: #ffd93d;
  color: #382e2b;
}
.lessons-wrapper {
  background-color: #382e2b;
  color: white;
}
hr {
  background-color: white;
}
.logo {
    width: 180px;
    transition: width 0.3s;    
  }
  .logo svg .st0 {
    fill: white;
  }
  @media (min-width: 992px) { 
    .logo {
        width: 200px;
    }
  }
 

</style>

<style>
#teacher_guide_wrapper .intro-description p a {
  color: white;
  text-decoration: underline;
}
#teacher_guide_wrapper .smaller p {
  font-size: 20px;
  line-height: 32px;
}
#teacher_guide-wrapper p, .p, ol li { 
    font-family: 'Utopia W01 Regular', serif;
    font-size: 20px;
    line-height: 32px;
    letter-spacing: 0;
}
</style>
 